import React from 'react';
import { Box, FormControlLabel, Switch } from '@mui/material';

interface HoverToggleSwitchProps {
  activeState: 'default' | 'hover';
  hoverEnabled: boolean;
  showAllHoverProps: boolean;
  updateImage: (updates: any) => void;
  setShowAllHoverProps: (value: boolean) => void;
  backgroundColor?: string;
  iconColor?: string;
}

const HoverToggleSwitch: React.FC<HoverToggleSwitchProps> = ({
  activeState,
  hoverEnabled,
  showAllHoverProps,
  updateImage,
  setShowAllHoverProps,
  backgroundColor,
  iconColor,
}) => {
  if (activeState !== 'hover') return null;

  return (
    <Box
      sx={{
        p: 1,

        borderTop: '1px solid lightgray',
        backgroundColor: backgroundColor,
        marginBottom: '15px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ pl: 1, color: iconColor }}>Hover Effects</Box>
        <Switch
          checked={hoverEnabled}
          onChange={(e) => updateImage({ hoverEnabled: e.target.checked })}
          size="small"
          color="primary"
        />
      </Box>

      {hoverEnabled && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ pl: 1, color: iconColor }}>Customize</Box>
          <Switch
            checked={showAllHoverProps}
            onChange={(e) => setShowAllHoverProps(e.target.checked)}
            size="small"
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};

export default HoverToggleSwitch;
